<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">汇辰学院</el-breadcrumb-item>
      <el-breadcrumb-item>课程标签</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">


          <el-form-item label="课程标签" prop="name">
            <el-input size="small" style="width: 200px;" v-model="formInline.name" placeholder="课程标签"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList(1)" >搜索</el-button>
            <el-button size="small" type="primary" @click="handleEdit()" >添加</el-button>
            <el-button size="small" type="danger" @click="handlePlDel" >批量删除</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" ref="tabs" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;"
                  :row-key="(row) => { return row.id }"  @selection-change="handleSelectionChangeDel">


          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="name" label="课程标签" align="center"></el-table-column>

          <el-table-column prop="sort" label="排序" align="center"></el-table-column>

          <el-table-column align="center"  prop="createTime" label="创建时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="handleEdit(scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.row)"style="width: 100px;margin: 1px;">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>




        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="150px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="课程标签" prop="name">
              <el-input size="small"  v-model="editForm.name" style="width: 300px"  auto-complete="off" placeholder="课程标签"></el-input>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="排序" v-model="editForm.sort" style="width: 250px"></el-input-number>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>




      </el-main>
    </el-container>
  </div>
</template>

<script>


import {qryCourseLabel,addCourseLabel,upCourseLabel,delCourseLabel,delCourseLabelPl} from '../../api/couApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from "../../components/wangeditor";


export default {
  name: "userList",

  data() {
    return {
      title:'修改',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        name:'',
        page:1,
        pageSize:10
      },
      listData:[],
      multipleSelection:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm:{
        id:'',
        name:'',
        sort:'',
      },
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
      },

    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(e){
      if (e == 1){
        this.formInline.page = 1
      }
      this.loading = true;
      qryCourseLabel(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })

    },

    resetFrom(){
      this.formInline.name = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },



    //显示编辑界面
    handleEdit: function(row) {
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.sort = row.sort
        this.editFormVisible = true
      } else {
        this.title = '添加'
        this.editFormVisible = true
        this.clear()
      }
    },

    clear(){
      this.editForm.id = ''
      this.editForm.name = '';
      this.editForm.sort = '';
    },





    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.editFormVisible = false;
      this.clear();
    },



    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upCourseLabel(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList()
                this.clear()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            addCourseLabel(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                  this.clear()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },



    deleteData(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delCourseLabel(row)
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已更新!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    handleSelectionChangeDel(val){
      this.multipleSelection = val;
    },



    handlePlDel() {
      if (this.multipleSelection.length === 0){
        this.$message.error('请选择数据！')
        return
      }
      this.isDisabled = true;
      var data = {
        ids:this.multipleSelection.map(element=>element.id)
      }
      this.$refs.tabs.clearSelection();
      delCourseLabelPl(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList();
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },




  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/cou/ccate.vue